import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

type LogoPrimaryProps = {
  size?: number;
};

function LogoPrimary({ size = 120 }: LogoPrimaryProps) {
  const s = size;
  return (
    <svg width={s} height={s} xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 970.1 970.1">
      <defs>
        <linearGradient id="linear-gradient" x1="965" x2="132.2" y1="1428.9" y2="1900.5" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#1296df" />
          <stop offset=".2" stopColor="#1296df" />
          <stop offset=".8" stopColor="#4f0cc1" />
          <stop offset="1" stopColor="#500ac1" />
        </linearGradient>
        <linearGradient id="linear-gradient-2" x1="378.1" x2="350.1" y1="880.3" y2="1467.8" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#46e9df" />
          <stop offset="1" stopColor="#1296df" />
        </linearGradient>
        <linearGradient id="linear-gradient-3" x1="968.5" x2="497.8" y1="1014.4" y2="1194.7" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#1296df" />
          <stop offset="1" stopColor="#4e0cc1" />
        </linearGradient>
        <linearGradient id="linear-gradient-4" x1="664.4" x2="355.4" y1="947.6" y2="1119.2" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#2c4bc5" />
          <stop offset=".5" stopColor="#2c219c" />
          <stop offset="1" stopColor="#1a227c" />
        </linearGradient>
        <linearGradient id="linear-gradient-5" x1="1072.3" x2="790.1" y1="1383.8" y2="1397.9" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#2e56d1" />
          <stop offset="1" stopColor="#4b13c3" />
        </linearGradient>
        <linearGradient id="linear-gradient-6" x1="1045.2" x2="632.4" y1="1218.2" y2="1224" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#2948bb" />
          <stop offset=".5" stopColor="#272596" />
          <stop offset="1" stopColor="#142575" />
        </linearGradient>
        <linearGradient id="linear-gradient-7" x1="632.3" x2="1044.4" y1="1519.3" y2="1519.4" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#142476" />
          <stop offset=".5" stopColor="#272192" />
          <stop offset="1" stopColor="#2a43b9" />
        </linearGradient>
      </defs>
      <path fill="#4b5da4" d="M505 702v1c-3.4-.3-7.5 0-11 0 2.7-2 7.5-.7 11-1Z" />
      <path fill="url(#linear-gradient)" d="M939 656a489 489 0 0 1-427.4 314.1H0V778.6C4.6 708.3 50.7 707 109.5 703c126.2.3 252.3-.2 378.5 0 5.3 2 12.3 1 18 1h119c37.8-.4 75.3-1.5 113-4 3.2-.1 7.7 1 10-1 32-.2 69.6-4.9 101.2-10.2 30.4-5.1 66.2-12.1 89.8-32.7Z" />
      <path fill="#304eb5" d="M494 703c3.5 0 7.6-.3 11 0 .5 0 1 .6 1 1-5.7 0-12.7.9-18-1h6Z" />
      <path fill="#214fb0" d="M625 704h-92c30.6 0 61.4.4 92 0Z" />
      <path fill="url(#linear-gradient-2)" d="M544.5 3c-2.7 0-7-.7-9 1a243 243 0 0 0-47.6 5c-2.3.7-1.6.6-5 1.3-77 15-143.8 51.3-182.5 120.7-23.3 42-30.8 82-31.7 130 0 2.8 1 6.1 1 7-.8 64.2 4.3 145.3-8.3 207.2-17.7 87-82 88.1-158.2 93.9-34.3 1-68.8 1.1-103.2 1V0h518l26.5 3Z" />
      <path fill="url(#linear-gradient-3)" d="M541 3c10.2.2 22 2.5 32.2 4.4A484.7 484.7 0 0 1 948 340a71 71 0 0 0-12-13.5c-42.5-36.6-141.1-47.2-196-52.4-1.7-2-5.5-.7-8-1-15.3-1.4-29.5-3-45-3-2-2-6.1-1-9-1-31.6-1.5-63.2-2.7-95-3h-72.5l-17.5 2c-11.2-.6-22.7 0-34 0-1-1.7-3.8-1-5.5-1-25.8-.3-51.7 0-77.5 0a143.9 143.9 0 0 1-9-45c-.3-7-.3-15 0-22 2.3-56.4 39.5-105.7 81.5-140A411 411 0 0 1 538 5c-.2-1.9-4.6-1-6-1 2-1.8 6.2-1.1 9-1Z" />
      <path fill="#261c8d" d="m267 261 1 6h106v1H268c0-.9-1-4.2-1-7Z" />
      <path fill="#4326c7" d="M376 267c25.8 0 51.7-.2 77.5 0 1.7 0 4.5-.6 5.5 1-28.3-.2-56.7 0-85 0v-1h2Z" />
      <path fill="url(#linear-gradient-4)" d="M538.4 4c1.5 0 6-.8 6.2 1a422.8 422.8 0 0 0-91.7 55c-43 34.4-81 83.7-83.5 140a47.8 47.8 0 0 0 0 22c.7 15.4 3.7 30.6 9.2 45H268l-1-6c.9-48 8.5-88 32.2-130C338.6 61.6 406.8 25.3 485 10.3c3.4-.7 2.8-.6 5-1.2 10.4-3 37.5-5.2 48.5-5Z" />
      <path fill="#3839c1" d="M583 266a2401 2401 0 0 0-53 0h53Z" />
      <path fill="#4b13c3" d="M367 222a49 49 0 0 1 0-22c-.3 7-.3 15 0 22Z" />
      <path fill="url(#linear-gradient-5)" d="M853 333.6a353 353 0 0 1 94 8.3c.9 0 .7-1.6.5-2a503.5 503.5 0 0 1-8 321.9c-1.7-1.5-3.2-.7-5-.6-12.1 1-24 1.4-36.2 1.6-17.3.3-35 .4-52.3 0-50-1.2-156-13.7-159.7-81.8v-13.9a232 232 0 0 0-3-164.5c26.7-27 61.3-46.4 97.4-57.1a280 280 0 0 1 63.3-10.8c3-.2 7-1 9-1Z" />
      <path fill="url(#linear-gradient-6)" d="M530 260a2229.4 2229.4 0 0 1 148 3.2c2 2 6.2 1 9 1.1 15.5.1 29.7 1.8 45 3.3 2.2.2 5.3.8 8 1 54.9 5.7 153.5 17.2 196 57.1 2.7 2.6 11 11.7 12 14.7.2.5.3 2.3-.5 2.2A331 331 0 0 0 854 334c-2.8.4-7-1.2-9 1.1a263.7 263.7 0 0 0-63 11.4 226.6 226.6 0 0 0-97 60.4c-32-83.7-108.8-140.7-192-144.7l17.5-2.2H530Z" />
      <path fill="url(#linear-gradient-7)" d="M850.4 652H903c12.2-.2 24.3-.6 36.4-1.6 1.8-.2 3.3-1 5 .5l-1 3.1c-23.9 21.5-60 28.7-90.6 34s-70 10.5-102.3 10.7c-3.3 0-7.4-.8-10 1a2071 2071 0 0 1-114.2 4.2c-31 .3-62 0-93 0H506c-.1-.5-.5-1-1-1v-1c82-5.4 157-68.5 184.8-146.5v14C693.7 638 800 650.7 850.4 652Z" />
      <path fill="#282397" d="M748 699c-2.4 2-6.8.8-10 1 2.7-1.7 6.7-1 10-1Z" />
      <path fill="#24218d" d="M687 270c-2.8 0-7 .9-9-1 2.9.2 7-.8 9 1Z" />
      <path fill="#272697" d="M740 274c-2.7-.2-5.8-.8-8-1 2.5.4 6.3-1 8 1Z" />
      <path fill="#333ac1" d="M899 654h-52c17.2.4 34.8.3 52 0Z" />
      <path fill="#3a3acb" d="M854 334c-2 .1-6 .9-9 1 2-2 6.2-.6 9-1Z" />
    </svg>
  );
}
// Subcomponents from DraliaLanding.jsx
/*function LogoPrimary({ size = 120 }: { size?: number }) {
  const s = size;
  return (
    <svg width={s} height={s} xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 970.1 970.1">
      <defs>
        <linearGradient id="linear-gradient" x1="965" x2="132.2" y1="1428.9" y2="1900.5" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#1296df"/><stop offset=".2" stopColor="#1296df"/><stop offset=".8" stopColor="#4f0cc1"/><stop offset="1" stopColor="#500ac1"/></linearGradient>
        <linearGradient id="linear-gradient-2" x1="378.1" x2="350.1" y1="880.3" y2="1467.8" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#46e9df"/><stop offset="1" stopColor="#1296df"/></linearGradient>
        <linearGradient id="linear-gradient-3" x1="968.5" x2="497.8" y1="1014.4" y2="1194.7" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#1296df"/><stop offset="1" stopColor="#4e0cc1"/></linearGradient>
        <linearGradient id="linear-gradient-4" x1="664.4" x2="355.4" y1="947.6" y2="1119.2" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#2c4bc5"/><stop offset=".5" stopColor="#2c219c"/><stop offset="1" stopColor="#1a227c"/></linearGradient>
        <linearGradient id="linear-gradient-5" x1="1072.3" x2="790.1" y1="1383.8" y2="1397.9" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#2e56d1"/><stop offset="1" stopColor="#4b13c3"/></linearGradient>
        <linearGradient id="linear-gradient-6" x1="1045.2" x2="632.4" y1="1218.2" y2="1224" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#2948bb"/><stop offset=".5" stopColor="#272596"/><stop offset="1" stopColor="#142575"/></linearGradient>
        <linearGradient id="linear-gradient-7" x1="632.3" x2="1044.4" y1="1519.3" y2="1519.4" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#142476"/><stop offset=".5" stopColor="#272192"/><stop offset="1" stopColor="#2a43b9"/></linearGradient>
        <linearGradient id="linear-gradient-8" x1="965" x2="132.2" y1="1428.9" y2="1900.5" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#1296df"/><stop offset=".2" stopColor="#1296df"/><stop offset=".8" stopColor="#4f0cc1"/><stop offset="1" stopColor="#500ac1"/></linearGradient>
        <linearGradient id="linear-gradient-9" x1="378.1" x2="350.1" y1="880.3" y2="1467.8" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#46e9df"/><stop offset="1" stopColor="#1296df"/></linearGradient>
        <linearGradient id="linear-gradient-10" x1="968.5" x2="497.8" y1="1014.4" y2="1194.7" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#1296df"/><stop offset="1" stopColor="#4e0cc1"/></linearGradient>
        <linearGradient id="linear-gradient-11" x1="664.4" x2="355.4" y1="947.6" y2="1119.2" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#2c4bc5"/><stop offset=".5" stopColor="#2c219c"/><stop offset="1" stopColor="#1a227c"/></linearGradient>
        <linearGradient id="linear-gradient-12" x1="1072.3" x2="790.1" y1="1383.8" y2="1397.9" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#2e56d1"/><stop offset="1" stopColor="#4b13c3"/></linearGradient>
        <linearGradient id="linear-gradient-13" x1="1045.2" x2="632.4" y1="1218.2" y2="1224" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#2948bb"/><stop offset=".5" stopColor="#272596"/><stop offset="1" stopColor="#142575"/></linearGradient>
        <linearGradient id="linear-gradient-14" x1="632.3" x2="1044.4" y1="1519.3" y2="1519.4" gradientTransform="translate(-105.3 -889.6)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#1296df"/><stop offset=".2" stopColor="#1296df"/><stop offset=".8" stopColor="#4f0cc1"/><stop offset="1" stopColor="#500ac1"/></linearGradient>
      </defs>
      <path fill="url(#linear-gradient-dralia-1)" d="M485.1 0C217.3 0 0 217.3 0 485.1s217.3 485.1 485.1 485.1 485.1-217.3 485.1-485.1S752.9 0 485.1 0zm0 890.1c-223.4 0-405-181.6-405-405s181.6-405 405-405 405 181.6 405 405-181.6 405-405 405z"/>
      <path fill="url(#linear-gradient-dralia-2)" d="M485.1 80.1c-223.4 0-405 181.6-405 405s181.6 405 405 405 405-181.6 405-405-181.6-405-405-405zm0 730c-179.1 0-325-145.9-325-325s145.9-325 325-325 325 145.9 325 325-145.9 325-325 325z"/>
      <path fill="url(#linear-gradient-dralia-3)" d="M485.1 160.1c-179.1 0-325 145.9-325 325s145.9 325 325 325 325-145.9 325-325-145.9-325-325-325zm0 650c-134.6 0-245-110.4-245-245s110.4-245 245-245 245 110.4 245 245-110.4 245-245 245z"/>
      <path fill="url(#linear-gradient-dralia-4)" d="M485.1 240.1c-134.6 0-245 110.4-245 245s110.4 245 245 245 245-110.4 245-245-110.4-245-245-245zm0 570c-90.1 0-165-74.9-165-165s74.9-165 165-165 165 74.9 165 165-74.9 165-165 165z"/>
      <path fill="url(#linear-gradient-dralia-5)" d="M485.1 320.1c-90.1 0-165 74.9-165 165s74.9 165 165 165 165-74.9 165-165-74.9-165-165-165zm0 490c-45.1 0-85-39.9-85-85s39.9-85 85-85 85 39.9 85 85-39.9 85-85 85z"/>
      <path fill="url(#linear-gradient-dralia-6)" d="M485.1 400.1c-45.1 0-85 39.9-85 85s39.9 85 85 85 85-39.9 85-85-39.9-85-85-85zm0 410c-10 0-15-5-15-15s5-15 15-15 15 5 15 15-5 15-15 15z"/>
      <path fill="url(#linear-gradient-dralia-7)" d="M485.1 480.1c-10 0-15-5-15-15s5-15 15-15 15 5 15 15-5 15-15 15z"/>
      <path fill="url(#linear-gradient-dralia-8)" d="M485.1 0C217.3 0 0 217.3 0 485.1s217.3 485.1 485.1 485.1 485.1-217.3 485.1-485.1S752.9 0 485.1 0zm0 890.1c-223.4 0-405-181.6-405-405s181.6-405 405-405 405 181.6 405 405-181.6 405-405 405z"/>
      <path fill="url(#linear-gradient-dralia-9)" d="M485.1 80.1c-223.4 0-405 181.6-405 405s181.6 405 405 405 405-181.6 405-405-181.6-405-405-405zm0 730c-179.1 0-325-145.9-325-325s145.9-325 325-325 325 145.9 325 325-145.9 325-325 325z"/>
      <path fill="url(#linear-gradient-dralia-10)" d="M485.1 160.1c-179.1 0-325 145.9-325 325s145.9 325 325 325 325-145.9 325-325-145.9-325-325-325zm0 650c-134.6 0-245-110.4-245-245s110.4-245 245-245 245 110.4 245 245-110.4 245-245 245z"/>
      <path fill="url(#linear-gradient-dralia-11)" d="M485.1 240.1c-134.6 0-245 110.4-245 245s110.4 245 245 245 245-110.4 245-245-110.4-245-245-245zm0 570c-90.1 0-165-74.9-165-165s74.9-165 165-165 165 74.9 165 165-74.9 165-165 165z"/>
      <path fill="url(#linear-gradient-dralia-12)" d="M485.1 320.1c-90.1 0-165 74.9-165 165s74.9 165 165 165 165-74.9 165-165-74.9-165-165-165zm0 490c-45.1 0-85-39.9-85-85s39.9-85 85-85 85 39.9 85 85-39.9 85-85 85z"/>
      <path fill="url(#linear-gradient-dralia-13)" d="M485.1 400.1c-45.1 0-85 39.9-85 85s39.9 85 85 85 85-39.9 85-85-39.9-85-85-85zm0 410c-10 0-15-5-15-15s5-15 15-15 15 5 15 15-5 15-15 15z"/>
      <path fill="url(#linear-gradient-dralia-14)" d="M485.1 480.1c-10 0-15-5-15-15s5-15 15-15 15 5 15 15-5 15-15 15z"/>
    </svg>
  );
}*/

function SvgGear() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06A2 2 0 1 1 7.04 3.2l.06.06c.5.5 1.22.65 1.82.33A1.65 1.65 0 0 0 10.42 2.1V2a2 2 0 1 1 4 0v.09c0 .66.38 1.26.98 1.58.6.32 1.32.17 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82c.32.6.92.98 1.58.98H22a2 2 0 1 1 0 4h-.09c-.66 0-1.26.38-1.58.98z" />
    </svg>
  );
}

function SvgHandshake() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 13l-3 3a2 2 0 1 1-3-3l5-5a6 6 0 0 1 8.49-.11L16 9m-8 4l3 3a2 2 0 0 0 3 0l6-6a2 2 0 1 1 3 3l-5 5a6 6 0 0 1-8.49.11L8 15" />
    </svg>
  );
}

interface FeatureTileProps {
  titleLine1: string;
  titleLine2: string;
  titleLine3?: string; // Optional
  badge?: string; // Optional
  icon?: string; // 'gear' or 'handshake'
}

function FeatureTile({ titleLine1, titleLine2, titleLine3, badge, icon }: FeatureTileProps) {
  return (
    <div style={styles.tile}>
      <div style={styles.tileNoise} />
      <div style={styles.tileHead}>
        {badge ? (
          <span style={styles.badge}>{badge}</span>
        ) : icon === "gear" ? (
          <SvgGear />
        ) : icon === "handshake" ? (
          <SvgHandshake />
        ) : null}
      </div>
      <div style={{ height: 8 }} />
      <h3 style={styles.tileTitle}>
        {titleLine1}
        <br />
        {titleLine2}
        {titleLine3 ? (
          <>
            <br />
            {titleLine3}
          </>
        ) : null}
      </h3>
    </div>
  );
}

interface WordmarkProps {
  big?: boolean; // Optional
}

function Wordmark({ big }: WordmarkProps) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <span style={{ ...fonts.brand, fontSize: big ? 36 : 24, letterSpacing: big ? 6 : 4 }}>DRALIA</span>
      <span style={{ ...fonts.brandSub, fontSize: big ? 10 : 8, opacity: 0.7 }}>by AYI GROUP</span>
    </div>
  );
}

// Styles from DraliaLanding.jsx
const colors = {
  ink: "#0A0B2E",
  inkDeep: "#0e1050",
  deep: "#17145F",
  deep2: "#1C186B",
  purple: "#6b3bff",
  cyan: "#33d7ff",
  white: "#ffffff",
  slate: "#E8E9F7",
  tile: "#5D3CCB",
};

const fonts = {
  brand: { fontFamily: "'Montserrat', 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Arial", fontWeight: 800 },
  brandSub: { fontFamily: "'Montserrat', 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Arial", fontWeight: 600 },
  uiBold: { fontFamily: "'Montserrat', 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Arial", fontWeight: 800 },
  ui: { fontFamily: "'Montserrat', 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Arial", fontWeight: 600 },
};

// Explicitly type the styles object
const styles: { [key: string]: React.CSSProperties } = {
  page: { background: colors.inkDeep, color: colors.white, minHeight: "100dvh", display: "flex", flexDirection: "column" },

  heroWrap: {
    background: `radial-gradient(1200px 600px at 20% -10%, rgba(51,215,255,0.08), transparent 60%), linear-gradient(180deg, ${colors.deep2}, ${colors.deep})`,
    padding: "56px 24px 48px",
  },

  heroInner: {
    maxWidth: 1180,
    margin: "0 auto",
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    gap: 28,
    alignItems: "center",
    position: "relative",
  },

  brandCol: { display: "flex", flexDirection: "column", alignItems: "flex-start" },

  titleCol: { minWidth: 0 },

  h1: {
    ...fonts.uiBold,
    fontSize: 66,
    lineHeight: 1,
    letterSpacing: 1,
    textTransform: "uppercase",
  },

  subtitle: {
    ...fonts.ui,
    fontSize: 14,
    opacity: 0.8,
    marginTop: 10,
  },

  signInTop: {
    position: "absolute",
    right: 0,
    top: -18,
    ...fonts.ui,
    fontSize: 11,
    textDecoration: "none",
    color: colors.slate,
    opacity: 0.9,
  },

  lead: {
    ...fonts.uiBold,
    fontSize: 22,
    textAlign: "center",
    maxWidth: 920,
    margin: "38px auto 22px",
  },

  tilesRow: {
    maxWidth: 920,
    margin: "0 auto",
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 22,
  },

  tile: {
    position: "relative",
    background: colors.tile,
    borderRadius: 16,
    padding: 18,
    minHeight: 140,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    boxShadow: "0 10px 24px rgba(0,0,0,.25)",
    overflow: "hidden",
  },
  tileNoise: {
    pointerEvents: "none",
    position: "absolute",
    inset: 0,
    background:
      "radial-gradient(2px 2px at 10% 20%, rgba(255,255,255,.15) 0, transparent 40%), radial-gradient(2px 2px at 70% 40%, rgba(255,255,255,.08) 0, transparent 40%), radial-gradient(2px 2px at 40% 80%, rgba(255,255,255,.10) 0, transparent 40%)",
    opacity: 0.45,
  },
  tileHead: { height: 28, display: "flex", alignItems: "center" },
  badge: {
    ...fonts.uiBold,
    fontSize: 12,
    padding: "4px 10px",
    borderRadius: 999,
    background: "linear-gradient(90deg, #89f7fe, #66a6ff)",
    color: colors.deep2,
    letterSpacing: 1,
  },
  tileTitle: { ...fonts.uiBold, fontSize: 24, lineHeight: 1.05 },

  divider: { height: 40, background: colors.white, opacity: 0.9 },

  visionWrap: { background: colors.white, color: colors.ink, padding: "40px 24px 64px" },
  visionInner: {
    maxWidth: 1080,
    margin: "0 auto",
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    alignItems: "center",
    gap: 28,
  },
  visionBrand: { display: "flex", flexDirection: "column", alignItems: "flex-start" },
  visionCardWrap: { display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 10 },
  visionBadge: {
    ...fonts.uiBold,
    fontSize: 14,
    color: colors.white,
    background: colors.deep,
    borderRadius: 999,
    padding: "6px 16px",
    letterSpacing: 1,
  },
  visionBubble: {
    background: colors.deep,
    color: colors.white,
    borderRadius: 18,
    padding: "18px 22px",
    boxShadow: "0 12px 24px rgba(0,0,0,.18)",
    maxWidth: 520,
  },
  visionText: { ...fonts.ui, fontSize: 15, lineHeight: 1.35 },

  signinWrap: {
    background: colors.white,
    color: colors.ink,
    padding: "30px 24px 70px",
    textAlign: "center",
  },
  signinLead: { ...fonts.ui, fontSize: 14, opacity: 0.85, marginBottom: 12 },
  signinBtn: {
    ...fonts.uiBold,
    fontSize: 15,
    border: 0,
    padding: "12px 24px",
    borderRadius: 999,
    background: "linear-gradient(90deg, #6cf3ff, #4aa4ff, #6b3bff)",
    color: colors.white,
    cursor: "pointer",
    boxShadow: "0 10px 18px rgba(67, 105, 255, .35)",
  },
};

const cssReset = `
  *,*::before,*::after{box-sizing:border-box}
  html,body,#root{height:100%}
  body{margin:0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}
  @media (max-width: 980px){
    .mq-hero{grid-template-columns:1fr!important}
  }
  /* We'll inject media queries via attribute selectors since inline styles can't hold them */
`;

export default function Landing() {
  const navigate = useNavigate();

  const scope = 'openid email profile';
  const responseType = 'token id_token';
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
  const redirectUri = process.env.REACT_APP_GOOGLE_REDIRECT_URI || '';

  const loginWithGoogle = () => {
    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?response_type=${responseType}&client_id=${googleClientId}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}&nonce=random123`;
    window.location.href = authUrl;
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Responsive styles based on windowWidth
  const heroInnerResponsiveStyle: React.CSSProperties = {};
  const tilesRowResponsiveStyle: React.CSSProperties = {};
  const visionInnerResponsiveStyle: React.CSSProperties = {};

  if (windowWidth <= 980) {
    heroInnerResponsiveStyle.gridTemplateColumns = '1fr';
    tilesRowResponsiveStyle.gridTemplateColumns = 'repeat(2, 1fr)';
    visionInnerResponsiveStyle.gridTemplateColumns = '1fr';
  }
  if (windowWidth <= 600) {
    tilesRowResponsiveStyle.gridTemplateColumns = '1fr';
  }

  return (
    <main style={styles.page}>
      {/* TOP SECTION – Deep blue background */}
      <section style={styles.heroWrap}>
        <div style={{ ...styles.heroInner, ...heroInnerResponsiveStyle }}>
          <div style={styles.brandCol}>
            <LogoPrimary size={140} />
            <div style={{ height: 16 }} />
            <Wordmark />
          </div>

          <div style={styles.titleCol}>
            <h1 style={styles.h1}>
              <span>CENTRO</span>
              <span style={{ display: "block" }}>DIGITAL</span>
              <span style={{ display: "block" }}>INTELIGENTE</span>
            </h1>
            <p style={styles.subtitle}>La inteligencia de tu trabajo, en un solo lugar.</p>
          </div>

          <a style={styles.signInTop} href="#signin" onClick={loginWithGoogle}>Ingresar con Google</a>
        </div>

        <p style={styles.lead}>Dralia unifica herramientas, conocimiento y asistentes de inteligencia artificial para:</p>

        {/* Feature tiles */}
        <div style={{ ...styles.tilesRow, ...tilesRowResponsiveStyle }}>
          <FeatureTile titleLine1="Acelerar el" titleLine2="trabajo" titleLine3="diario" badge="UP" />
          <FeatureTile titleLine1="Estandarizar" titleLine2="procesos" icon="gear" />
          <FeatureTile titleLine1="Facilitar la" titleLine2="colaboración" titleLine3="entre equipos" icon="handshake" />
        </div>
      </section>

      {/* DIVIDER */}
      <div style={styles.divider} />

      {/* VISION SECTION */}
      <section style={styles.visionWrap}>
        <div style={{ ...styles.visionInner, ...visionInnerResponsiveStyle }}>
          <div style={styles.visionBrand}>
            <LogoPrimary size={132} />
            <div style={{ height: 12 }} />
            <Wordmark big />
          </div>

          <div style={styles.visionCardWrap}>
            <div style={styles.visionBadge}>VISIÓN</div>
            <div style={styles.visionBubble}>
              <p style={styles.visionText}>
                Integrar personas, datos y automatización en una experiencia única que entregue respuestas confiables,
                trazables y accionables en segundos.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SIGN-IN SECTION */}
      <section id="signin" style={styles.signinWrap}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginBottom: 6 }}>
          <LogoPrimary size={34} />
          <span style={{ ...fonts.brand, fontSize: 14, letterSpacing: 2 }}>DRALIA</span>
        </div>

        <p style={styles.signinLead}>Inicia sesión con tu cuenta de Google</p>

        <button style={styles.signinBtn} type="button" onClick={loginWithGoogle}>
          Iniciar sesión
        </button>
      </section>

      <footer style={{ height: 28 }} />

      <style>{cssReset}</style>
    </main>
  );
}
